"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeConfig = void 0;
const server_types_1 = require("../server-types");
const types_1 = require("../types");
const defaultConfig = {
    GOOGLE_AUTH_URL: 'https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&response_type=code&client_id=686200956517-ekcd649hqj7nuf6q19grqp9ofqlvnqu4.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/userinfo.email+https://www.googleapis.com/auth/userinfo.profile',
    LINKEDIN_AUTH_URL: 'https://www.linkedin.com/oauth/v2/authorization?scope=r_liteprofile,r_emailaddress&access_type=offline&response_type=code&client_id=86cpchio1khn04',
    FACEBOOK_AUTH_URL: 'https://www.facebook.com/v3.0/dialog/oauth?scope=public_profile,email,user_location&access_type=offline&response_type=code&client_id=168668320473884',
    APPLE_AUTH_URL: 'https://appleid.apple.com/auth/authorize?response_type=code&client_id=wwg.foodmt.app',
    AUTH_ENDPOINT: 'https://api2.italianfood.net/api/authenticate',
    FORGOT_PASSWORD_ENDPOINT: 'https://api2.italianfood.net/api/forgot-password',
    LOGIN_START_TRADITIONAL: false,
    HELP_EMAIL: 'support@gruppofood.com',
    OAUTH_REDIRECT_URI: 'https://auth.gruppofood.com/oauth2callback',
    DEFAULT_LOGGED_ROUTE: '/',
    AUTH_ROLES: [server_types_1.UserRole.Consumer],
    SOCIAL_TYPES: [types_1.SOCIAL.GOOGLE, /*SOCIAL.FACEBOOK,*/ types_1.SOCIAL.LINKEDIN, types_1.SOCIAL.APPLE],
    LANG: 'it_IT',
    TARGET_SITE: 'IFN',
    VERIFICATION_URL: '/login',
};
const mergeConfig = (c) => {
    const merged = Object.assign({}, defaultConfig, c);
    if (!merged.AUTH_ENDPOINT) {
        merged.AUTH_ENDPOINT = '';
    }
    return merged;
};
exports.mergeConfig = mergeConfig;
//# sourceMappingURL=config.js.map